import React from 'react';
import PropTypes from 'prop-types';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core";  
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GSPDReport from './WorkerReport/GSPDReport';
import WorkerWiseEfficiencyReport from './WorkerReport/WorkerWiseEfficiencyReport';
import WorkerWiseMultiMachineAllowanceReport from './WorkerReport/WorkerWiseMultiMachineAllowanceReport';
import WorkCenterUtilisationReport from './WorkCenterReport/WorkCenterUtilisationReport';
import WorkCenterWiseLosses from './WorkCenterReport/WorkCenterLossesReport';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function Reports() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [expanded, setExpanded] = React.useState(false);

    const handleChangeAccordion = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data mt-2">
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                        centered
                    >
                        <Tab label="Worker Report" {...a11yProps(0)} />
                        <Tab label="Workcenter Report" {...a11yProps(1)} />
                    
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Accordion className="mt-1" expanded={expanded === 'panel1'} onChange={handleChangeAccordion('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                        <Typography className={classes.heading}>Worker Wise Efficiency Report</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkerWiseEfficiencyReport />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="mt-1" expanded={expanded === 'panel2'} onChange={handleChangeAccordion('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                        <Typography className="">Worker Wise Multi-Machine Allowance Report</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkerWiseMultiMachineAllowanceReport />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="mt-1" expanded={expanded === 'panel3'} onChange={handleChangeAccordion('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                        >
                        <Typography className={classes.heading}>GSPD Report</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GSPDReport />
                        </AccordionDetails>
                    </Accordion>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Accordion className="mt-1" expanded={expanded === 'panel4'} onChange={handleChangeAccordion('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                        >
                            <Typography className={classes.heading}>Work Center Utilisation Report</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkCenterUtilisationReport />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="mt-1" expanded={expanded === 'panel5'} onChange={handleChangeAccordion('panel5')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel5a-content"
                            id="panel5a-header"
                        >
                            <Typography className="">Work Center Wise Losses</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkCenterWiseLosses />
                        </AccordionDetails>
                    </Accordion>
                    {/*<Accordion className="mt-1" expanded={expanded === 'panel6'} onChange={handleChangeAccordion('panel6')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel6a-content"
                            id="panel6a-header"
                        >
                            <Typography className={classes.heading}>Work Center Wise Idle Time</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkCenterWiseIdleTime />
                        </AccordionDetails>
                    </Accordion>*/}
                </TabPanel>
            </div>
        </ThemeProvider>
    );
}